<!-- 券商投诉 -->
<template>
  
  <div class="container">
    <!-- <TEditor ></TEditor> -->
    <banner></banner>
    <div class="content" v-show="!drawer"   v-if="hasToken" style="width: 100%;">
      <div
        class="content_left"
        style="width: 856px;border-radius: 8px 8px 8px 8px;
height: 607px;background-color: #ffffff; overflow-y: auto;"
      >
        <!-- <div class="complaint">
          <el-select 
            v-model="ruleForm.name" 
            placeholder="请选择投诉公司" 
            class="custom-select"
            popper-class="select-dropdown"
          >
            <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            />
          </el-select>

          <el-input
            placeholder="请输入投诉内容"
            class="custom-textarea"
            type="textarea"
            v-model="ruleForm.desc"
          ></el-input>

          <el-form-item>
            <el-button @click="Publish" type="primary">立即提交</el-button>
          </el-form-item>
        </div> -->
     <div class="content_left_item"  v-for="(item) in filteredComplaints" :key="item.id">
      <div class="top_flex">
      <!-- <img :src= "item.company.avatar" width="150px" height="80px" style="border-radius: 4px 4px 4px 4px;"> -->
      <div style=" flex-direction: column;margin-left: 16px;">
      <h2   style="font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20; 
font-weight: 700;
font-size: 16px;
color: #1F222E;
line-height: 28px;">{{item.company_name }}</h2>

<!-- <p style="margin-top: 6px;{{ formatContent(item.content) }}</p> -->
  <p :class="{'custom-content': true}" style="margin-top: 6px;" v-html="processedContent1(item.content)"></p>
<p style="margin-top: 2px;">{{ formatDate(item.complaint_time) }}</p>
</div>
</div>
     </div>
     
      </div>
      <div
        class="content_right"
        style="width: 474px;
margin-left: auto;
background: #FFFFFF;
border-radius: 8px 8px 8px 8px;
height: 497px;"
      >
      <div style="display: flex;">
        <h2
          style="font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
font-weight: 700;
font-size: 20px;
color: #1F222E;
line-height: 28px;padding: 16px;"
        >我的投诉</h2><div style="margin-top: 20px;margin-left: 290px;" @click="GoRegister"  > <el-icon ><EditPen  /></el-icon>投诉</div></div>
        <span :class="{ active: activeStatus === 'pending' }" @click="filterByStatus('pending')">待审核</span>
        <span
          :class="{ active: activeStatus === 'approved' }"
          @click="filterByStatus('approved')"
        >已审核</span>
        <span :class="{ active: activeStatus === 'rejected' }" @click="filterByStatus('rejected')">未通过</span>
        <div class="complaint-list-container">
          <div class="complaint_list" v-for="(item) in filteredComplaints" :key="item.id">
            <span
              v-if="item.approval_status_display==='未通过'"
              style="font-size: 14px; "
              class="status-tag failed"
            >未通过</span>
            <span
              v-else-if="item.approval_status_display==='待审核'"
              style="font-size: 14px; "
              class="status-tag pending"
            >待审核</span>
            <span v-else class="status-tag approved" style="font-size: 14px; ">已审核</span>

            <h2
              style="font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
font-weight: 700;
font-size: 18px;
color: #1D2129;"
            >{{ item.company_name }}</h2>

            <p v-html="processedContent(item.content)"></p>

<div class="del_button"><p style="padding-top: 4px;font-size: 12px;">{{ formatDate(item.complaint_time) }}</p><button  @click="handleDelete(item.id)"
  
  >删除</button></div>
<span v-if="item.approval_status_display==='未通过'" style="font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
font-weight: 400;
font-size: 14px;
color: #EE3F5E;
line-height: 20px;position: absolute; margin-top: -20px;margin-left: -16px"
              >
                {{ item.complaint_type_display
                }}
              </span>
          </div>
        </div>
      </div>
      
    </div>

    <!-- 添加登录提示弹窗 -->
    <el-dialog
    style=" background: linear-gradient( 135deg, #9BDCFF 0%, #2F80ED 100%); color: white;"
      v-model="showLoginTip"
      title="登录提示"
      width="400px"
      :show-close="false"
      center
      class="login-tip-dialog"
    >
      <div class="login-tip-content">
        <i class="el-icon-info tip-icon"></i>
        <span style="color: white;">您还未登录，请先登录后再进行操作</span>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <GSAPbutton @click="cancelLogin">确定</GSAPbutton>
          
        </span>
      </template>
    </el-dialog>

    <!-- 添加删除确认弹窗 -->
    <el-dialog
      style="color: white; background: linear-gradient( 135deg, #FAEBD7 0%, #F75D59 100%); "
      v-model="showDeleteConfirm"
      title="删除确认"
      width="400px"
      :show-close="false"
      center
 
    >
      <div class="delete-confirm-content">
        <i class="el-icon-warning tip-icon"></i>
        <span>确定要删除这条投诉吗？</span>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="cancelDelete" >取消</el-button>
          <button type="danger" @click="confirmDelete"  class="gsap-button"
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
      @mousemove="handleMouseMove"  
      ref="button">确定删除</button>
        </span>
      </template>
    </el-dialog>
 
  
    
<TEditor  v-show="drawer" v-if="hasToken" :is="editorComponent"   class="editor"  @update:drawer="handleCloseDrawer"></TEditor>



    
  </div>
 
</template>

<script >
import { getComplaintList, postComplaint, login, deleteComplaint, getCompanyList,QgetCompanyList } from '@/api/api'
import { getToken } from '@/utils/store'
import { ElMessage } from 'element-plus'
import banner from '@/views/layout/components/banner.vue'
import GSAPbutton from "@/utils/GSAPbutton.vue";
import { gsap } from "gsap";

 import TEditor from "../../components/TEditor"
 import { ref } from 'vue'

export default {
  components: {banner,GSAPbutton,TEditor},
  filters: {
    escapeHTML(value) {
      if (!value) return '';
      return value
        .replace(/</g, '<')
        .replace(/>/g, '>');
    }
  },
  data() {
    return {
      Complainlist: [],
      drawer:false,
      editorComponent: null,
      showComplaint: false, // 确保初始化
      enterAngle: 0, // 用来存储鼠标进入时的角度
      ruleForm: {
        name: "",
        desc: ""
      },
      username: "13038093674",
      password: "yourpassword123",
      activeStatus: "pending",
      companyList: [],
      hasToken: !!getToken('token'),
      showLoginTip: false,
      stopChecking: false,
      showDeleteConfirm: false,
      showComplaint:false,
      deleteItemId: null  // 存储要删除的项目ID
    }
  },
  computed: {
    
    filteredComplaints() {
      if (this.activeStatus === "pending") {
        return this.Complainlist.filter(
          item => item.approval_status_display === "待审核"
        );
      } else if (this.activeStatus === "approved") {
        return this.Complainlist.filter(
          item => item.approval_status_display === "已审核"
        );
      } else if (this.activeStatus === "rejected") {
        return this.Complainlist.filter(
          item => item.approval_status_display === "未通过"
        );
      }
      return this.Complainlist;
    }
  },
  watch: {
    drawer(newValue) {
      this.loadEditor();
      this.getComplaintList1()
        if (newValue) {
          this.$nextTick(() => {
        // Fade out the content and slide it to the left
        gsap.to(".content", {
          opacity: 0, // Fade out the content
          y: "-5%", // Slide out to the left
          duration: 1, // 1 second duration for smooth transition
          ease: "power2.out",
        });

        // Slide in the editor and fade it in
      
        gsap.from(".editor", {
          opacity: 0, // Start with opacity 0 (hidden)
          y: "5%", // Start from the right of the screen
          duration: 1,// 1 second duration for smooth transition
          ease: "power2.out",
        });
      })
      } else {
        // Reverse the animations when closing the drawer
        gsap.to(".content", {
          opacity: 1, // Fade back in
          y: "0%", // Slide content back into view
          duration: 1,
          ease: "power2.out",
        });

        gsap.to(".editor", {
          opacity: 1, // Fade out the editor
          y: "0%", // Move it out to the right
          duration: 1,
          ease: "power2.out",
        });
      }
       
    
    
    },
  
    hasToken: {
      handler(newValue) {
        if (newValue) {
          this.getComplaintList1()
        }
      },
      immediate: true
    }
  },
  methods: {
     // 处理 content 内容，添加图片和文字之间的间隔
     processedContent1(content) {
      // 替换 <img> 标签，在图片的前后加上一个 class，添加间隔
      let processedContent = content.replace(/<img[^>]*>/g, (match) => {
        // 为图片标签添加 margin 样式
        return match.replace(/<img/, '<img style="margin-left: 10px; margin-right: 10px;"');
      });

      return processedContent;
    },
      // 处理 content 内容，去掉 <p> 标签并替换 <img> 标签为 (图片)
        processedContent(content) {
      // 去掉 <p> 标签
      let processedContent = content.replace(/<\/?p>/g, "");

      // 替换 <img> 标签为 (图片)
      processedContent = processedContent.replace(/<img[^>]*>/g, "（ 图片 ）");

      return processedContent;
    },
    loadEditor() {
      import('@/components/TEditor').then(module => {
        this.editorComponent = module.default;
      });},
    handleCloseDrawer(newState) {
      this.drawer = newState;
    },
  
    initTEditor() {
      // 确保TEditor已经渲染
      this.$nextTick(() => {
        if (this.$refs.editor) {
          GoRegister()
        }
      });
    },
    GoRegister(){
      this.showComplaint = true;
      this.drawer = true
     
      
    },
    handleMouseEnter(event) {
      this.$nextTick(() => {
        const button = this.$refs.button;
        if(button){
          const rect = button.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;
      const width = button.offsetWidth;
      const height = button.offsetHeight;

      // 计算鼠标进入按钮时的角度
      const angle = Math.atan2(y - height / 2, x - width / 2);
      this.enterAngle = (angle + Math.PI) / (2 * Math.PI); // 将角度转化为 0-1 的值

      // 将角度转换为 360 度，并使用 GSAP 动画填充颜色
      const angleDeg = this.enterAngle * 360;

      // 鼠标移入时，背景开始填充
      gsap.to(button, {
        background: `linear-gradient(${angleDeg}deg, #55A5FA, #55A5FA)`, // 根据鼠标角度动态填充背景
        duration: 1.2,
        ease: "power2.out",
        backgroundSize: "200% 200%", // 扩大背景区域，模拟填充效果
        scaleX: 1.1, // 按钮的缩放，增强效果
        scaleY: 1.1, // 按钮的缩放，增强效果
    
      });

      this.isMouseEntered = true; // 标记鼠标已进入
        }
      })
     
    
    },

    handleMouseMove(event) {
      if (!this.isMouseEntered) return; // 只有在鼠标进入时才进行处理
     
      this.$nextTick(() => {
        const button = this.$refs.button;
        if (button) {
          const rect = button.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;
      const width = button.offsetWidth;
      const height = button.offsetHeight;

      // 计算鼠标在按钮内移动时的角度
      const angle = Math.atan2(y - height / 2, x - width / 2);
      const normalizedAngle = (angle + Math.PI) / (2 * Math.PI); // 转换为 0 到 1 之间的值
      const angleDeg = normalizedAngle * 360; // 将角度转换为 360 度

      // 使用 GSAP 动画平滑更新背景渐变的方向
      gsap.to(button, {
        background: `linear-gradient(${angleDeg}deg, white, #F75D59)`, // 根据鼠标的角度动态调整背景
       color:'#F75D59',
        duration: 1.2, // 动画持续时间，快速响应
        ease: "power2.out",
      });
        }
    
      })
     
    },

    handleMouseLeave() {
      
      this.$nextTick(() => {
        const button = this.$refs.button;
        if (button) {
          gsap.to(button, {
        background: `linear-gradient(${this.enterAngle * 360}deg, white, white)`, // 沿着进入时的角度退出
        backgroundSize: "100% 100%", // 恢复背景大小
        duration: 1.2,
        ease: "power2.out",
       color:'#F75D59',
        scaleX: 1, // 恢复原始大小
        scaleY: 1, // 恢复原始大小
      });

      this.isMouseEntered = false; // 标记鼠标已离开
        }
          // 鼠标离开时，背景颜色沿着原来的路径平滑收回
    
      });
    
    },
    async getCompanyListall() {
      const res = await QgetCompanyList()
      // console.log('公司列表：', res)
      this.companyList = res
    },
        async getComplaintList1() {
        const token = getToken('token')
        if (!token) {
          // console.log('未登录，无法获取投诉列表')
          return
        }

        try {
          const res = await getComplaintList()
          console.log('投诉列表：', res)
          this.Complainlist = res.results
        } catch (error) {
          console.error('获取投诉列表失败：', error)
        }
  },
  async Publish() {
      try {
        const res = await login({
          username: "13038093674", // 直接传递username
          password: "yourpassword123" // 直接传递password
        });
        console.log("登录结果：", res.access);
      } catch (error) {
        console.error("登录失败：", error);
      }
      this.postComplaintSubmit();
    },
    async postComplaintSubmit() {
      const token = getToken('token')
      if (!token) {
        ElMessage({
          message: "未登录，请先登录！",
          type: "warning"
        });
        return;
      }

      // 添加输入验证
      if (!this.ruleForm.name.trim() || !this.ruleForm.desc.trim()) {
        ElMessage({
          message: "请确保公司名称和投诉内容不为空！",
          type: "warning"
        });
        return;
      }

      try {
        const res = await postComplaint({
          company_name: this.ruleForm.name,
          content: this.ruleForm.desc,
          complaint_type: "TYPE1",
          title: 'ok',
          location: '实现完美并无奖赏 追求完美却有终点'
        });

        this.ruleForm.name = '';
        this.ruleForm.desc = '';
        await this.getComplaintList1();
        
        ElMessage({
          message: "提交成功！",
          type: "success"
        });
      } catch (error) {
        ElMessage({
          message: "提交失败，请确保公司名称无误！",
          type: "error"
        });
        this.ruleForm.name=''
        this.ruleForm.desc=''
      }
    },
  
        formatContent(content) {
    if (!content) return '';
    return content.length > 50 ? content.slice(0, 50) + '...' : content;
  },
  filterByStatus(status) {
    this.activeStatus = status
  },
  handleDelete(id) {
    this.deleteItemId = id
    this.showDeleteConfirm = true
  },
  cancelDelete() {
    this.showDeleteConfirm = false
    this.deleteItemId = null
  },
  async confirmDelete() {
    try {
      await deleteComplaint(this.deleteItemId)
      await this.getComplaintList1()
      ElMessage({
        message: "删除成功！",
        type: "success"
      })
      this.showDeleteConfirm = false
      this.deleteItemId = null
    } catch (error) {
      console.error('删除失败：', error)
      ElMessage({
        message: "删除失败，请重试",
        type: "error"
      })
    }
  },
  formatDate(dateString) {
    if (!dateString) return ''
    const date = new Date(dateString)
    return date.toLocaleString('zh-CN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    }).replace(/\//g, '-')
  },
  async getCompanyOptions() {
    try {
      const res = await getCompanyList()
    } catch (error) {
      console.error('获取公司列表失败：', error)
    }
  },
  checkToken() {
    this.hasToken = !!getToken('token')
    if (!this.hasToken && !this.stopChecking) {
      this.showLoginTip = true
    }
  },
  cancelLogin() {
    this.showLoginTip = false
    this.stopChecking = true
  },
  goToLogin() {
    this.showLoginTip = false
    // 获取全局的 menu 组件并显示登录弹窗
    const menu = document.querySelector('.menu').__vue__
    if (menu) {
      menu.loginDialogVisible = true
    }
  }
  },
  created  () {
  
  },
  mounted  () {
  
    this.getCompanyListall()
    const token = getToken('token')
    if (token) {
      this.getComplaintList1()
    } else {
      console.log('未登录状态')
    }
    this.getCompanyOptions()
    this.tokenChecker = setInterval(() => {
      this.checkToken()
    }, 1000)
  },
  beforeUnmount() {
    if (this.tokenChecker) {
      clearInterval(this.tokenChecker)
    }
  },
}

</script>
<style lang='scss' scoped>
:deep(.el-textarea__inner) {
  width: 822px;
  height: 335px;
  background: #f8f7fb;
  border-radius: 4px 4px 4px 4px;
  margin-top: 14px;
  margin-bottom: 16px;
  font-family: Alibaba PuHuiTi 2, Alibaba PuHuiTi 20;
  font-weight: 400;
  font-size: 14px;
  color: #7e7f83;
  line-height: 20px;
  padding-left: 16px;
}
.custom-input {
  width: 808px;

  height: 57px;
  line-height: 30px;
  background: #f8f7fb;
  border-radius: 4px 4px 4px 4px;

  font-family: Alibaba PuHuiTi 2, Alibaba PuHuiTi 20;
  font-weight: 400;
  font-size: 18px;
  color: #7e7f83;
  padding-left: 16px;
}
.complaint {
  padding: 16px;
}
.content_right span {
  font-weight: 700;
  font-size: 18px;
  color: #7e7f83;
  line-height: 25px;
  padding: 16px;
  cursor: pointer;

  &.active {
    color: black;
  }
}
.complaint-list-container {
  height: 400px;
  overflow-y: auto;
  
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}
.complaint_list {
  position: relative;
  margin: 16px auto;
  padding: 16px;
  width: 402px;
  height: 105px;
  background: #f8f7fb;
  border-radius: 4px 4px 4px 4px;
}
.complaint_list p {
  font-family: Alibaba PuHuiTi 2, Alibaba PuHuiTi 20;
  font-weight: 400;
  font-size: 14px;
  color: #7e7f83;
  line-height: 20px;
  padding-top: 8px;
}
.del_button {
  display: flex;
}
.del_button button {
  margin-left: auto;
  width: 60px;
  height: 28px;
  border-radius: 2px 2px 2px 2px;
  border: 1px solid #7e7f83;
  font-family: Alibaba PuHuiTi 2, Alibaba PuHuiTi 20;
  font-weight: 400;
  font-size: 14px;
  color: #7e7f83;
  line-height: 20px;
}
.status-tag {
  width: 62px;
  height: 10px;
  position: absolute;
  right: 1px;
  top: 1px;
  text-align: center;
  border-radius: 0px 4px 0px 0px;
  line-height: 20px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;

  &.failed {
    background: #fbe6eb;
    color: #ee3f5e;
  }

  &.pending {
    background: #fdf3d0;
    color: #f0961b;
  }

  &.approved {
    background: #d0f5ea;
    color: #23ae84;
  }
}
.custom-select {
  width: 823px;
}

:deep(.el-input__wrapper) {
  background-color: #f8f7fb !important;
  box-shadow: none !important;
  height: 57px;
  padding: 0 16px;
}

:deep(.el-input__inner) {
  height: 57px;
  font-family: Alibaba PuHuiTi 2, Alibaba PuHuiTi 20;
  font-weight: 400;
  font-size: 18px;
  color: #7e7f83;
}

/* 下拉框样式 */
:deep(.select-dropdown) {
  .el-select-dropdown__item {
    font-family: Alibaba PuHuiTi 2, Alibaba PuHuiTi 20;
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    
    &.selected {
      color: #1890ff;
      font-weight: 700;
    }
  }
}
.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 20px;
  color: white;
}

:deep(.login-tip-dialog) {
  .el-dialog__header {
    padding: 20px;
    margin: 0;
   
    border-radius: 8px 8px 0 0;
    
    .el-dialog__title {
      color: white;
      font-size: 18px;
      font-weight: 500;
    }
  }
  
 

  .el-dialog__body {
    padding: 30px 20px;
  }
}

.login-tip-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #606266;
  font-size: 16px;
  
  .tip-icon {
    color: #55A5FA;
    font-size: 20px;
  }
}

.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 20px;

  .login-btn {
    background-color: #55A5FA;
    border-color: #55A5FA;
    
    &:hover {
      background-color: #7ab8fb;
      border-color: #7ab8fb;
    }
  }
}

:deep(.delete-confirm-dialog) {
  .el-dialog__header {
    padding: 20px;
    margin: 0;
    background: #f56c6c;
    border-radius: 8px 8px 0 0;
    
    .el-dialog__title {
      color: white;
      font-size: 18px;
      font-weight: 500;
    }
  }
}

.delete-confirm-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
 
  font-size: 16px;
  
  .tip-icon {
    color: #f56c6c;
    font-size: 20px;
  }
}
.content_left_item{
  width: 790px;
  padding: 16px;

  background: #f8f7fb;
  margin-left: 16px;
  border-radius: 4px 4px 4px 4px;
  margin-top: 8px;
}
.top_flex{
  display: flex;
 
}
.custom-content img {
  margin: 10px 0;
}
.top_flex p{
  font-family: Alibaba PuHuiTi 2, Alibaba PuHuiTi 20;
  font-weight: 400;
  font-size: 14px;
  color: #7e7f83;
  line-height: 20px;
  
}
.gsap-button {
  width: 90px;
  height: 30px;
  background: white; 
  border-radius: 2px;
  border: 2px solid transparent; 
  margin-left: 20px;
  color: #F75D59; 
  border: none;
  cursor: pointer; 
  
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.gsap-button:focus {
  outline: none;
}
.content-slide-out {
  transform: translateX(-100%); /* Slide out the content */
}

.container {
  position: relative;
}

/* Initial position for content */
.content {
  display: flex;
  width: 100%;
  position: relative;
  opacity: 1; /* Start visible */
  transition: transform 0.1s ease, opacity 0.1s ease; 
}
.editor{
  margin-top: 16px;

}


</style>